import { axiosFetch } from "../../utils/AxiosFetch";
import { trainingConstants } from "../constants/training.constant";
import { SnackbarActions } from './snackbar.actions';

export const training_list = (req) => (dispatch) => {

    axiosFetch({
        url: "/Training/list",
        method: "post",
        requestConfig: req
    })
        .then((res) => {
            if (res.status === 200) {
                dispatch(training_list_success(res));
            }
            else if (res.status === 400) {
                dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
            }
            else if (res.status === 401) {
                window.location.href = '/';
            }

        },
            (err) => {

                dispatch(training_list_failure(err));
            }
        );


    function training_list_success(data) {

        return {
            type: trainingConstants.TRAINING_LIST_SUCCESS,
            payload: data
        }
    }

    function training_list_failure(err) {

        return {
            type: trainingConstants.TRAINING_LIST_FAILURE,
            payload: err
        }
    }

}


export const my_training = (req) => (dispatch) => {

    axiosFetch({
        url: "/Training/self",
        method: "post",
        requestConfig: req
    })
        .then((res) => {
            if (res.status === 200) {
                dispatch(training_list_success(res));
            }
            else if (res.status === 400) {
                dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
            }
            else if (res.status === 401) {
                window.location.href = '/';
            }

        },
            (err) => {

                dispatch(training_list_failure(err));
            }
        );


    function training_list_success(data) {

        return {
            type: trainingConstants.MY_TRAINING_SUCCESS,
            payload: data
        }
    }

    function training_list_failure(err) {

        return {
            type: trainingConstants.MY_TRAINING_FAILURE,
            payload: err
        }
    }

}


export const team_training = () => (dispatch) => {

    axiosFetch({
        url: "/Training/request",
        method: "get",
    })
        .then((res) => {
            if (res.status === 200) {
                dispatch(team_training_success(res));
            }
            else if (res.status === 400) {
                dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
            }
            else if (res.status === 401) {
                window.location.href = '/';
            }

        },
            (err) => {

                dispatch(team_training_failure(err));
            }
        );


    function team_training_success(data) {

        return {
            type: trainingConstants.TEAM_TRAINING_SUCCESS,
            payload: data
        }
    }

    function team_training_failure(err) {

        return {
            type: trainingConstants.TEAM_TRAINING_FAILURE,
            payload: err
        }
    }

}

export const training_details = (id) => (dispatch) => {

    axiosFetch({
        url: `/Training/${id}`,
        method: "get",
    })
        .then((res) => {
            if (res.status === 200) {
                dispatch(team_training_success(res));
            }
            // else if (res.status === 400) {
            //     dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
            // }
            else if (res.status === 401) {
                window.location.href = '/';
            }

        },
            (err) => {

                dispatch(team_training_failure(err));
            }
        );


    function team_training_success(data) {

        return {
            type: trainingConstants.TRAINING_DETAILS_SUCCESS,
            payload: data
        }
    }

    function team_training_failure(err) {

        return {
            type: trainingConstants.TRAINING_DETAILS_FAILURE,
            payload: err
        }
    }

}

export const ongoing_training = () => (dispatch) => {

    axiosFetch({
        url: `/Training/ongoing`,
        method: "get",
    })
        .then((res) => {
            if (res.status === 200) {
                dispatch(team_training_success(res));
            }
            else if (res.status === 400) {
                dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
            }
            else if (res.status === 401) {
                window.location.href = '/';
            }

        },
            (err) => {

                dispatch(team_training_failure(err));
            }
        );


    function team_training_success(data) {

        return {
            type: trainingConstants.ONGOING_TRAINING_SUCCESS,
            payload: data
        }
    }

    function team_training_failure(err) {

        return {
            type: trainingConstants.ONGOING_TRAINING_FAILURE,
            payload: err
        }
    }

}

export const external_training_list = (req) => (dispatch) => {

    axiosFetch({
        url: "/training/external/list",
        method: "post",
        requestConfig: req
    })
        .then((res) => {
            if (res.status === 200) {
                dispatch(training_list_success(res));
            }
            else if (res.status === 400) {
                dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
            }
            else if (res.status === 401) {
                window.location.href = '/';
            }

        },
            (err) => {

                dispatch(training_list_failure(err));
            }
        );


    function training_list_success(data) {

        return {
            type: trainingConstants.EXTERNAL_TRAINING_LIST_SUCCESS,
            payload: data
        }
    }

    function training_list_failure(err) {

        return {
            type: trainingConstants.EXTERNAL_TRAINING_LIST_FAILURE,
            payload: err
        }
    }

}


export const all_external_training = (req) => (dispatch) => {

    axiosFetch({
        url: "/training/external/all",
        method: "post",
        requestConfig: req
    })
        .then((res) => {
            if (res.status === 200) {
                dispatch(training_list_success(res));
            }
            else if (res.status === 400) {
                dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
            }
            else if (res.status === 401) {
                window.location.href = '/';
            }

        },
            (err) => {

                dispatch(training_list_failure(err));
            }
        );


    function training_list_success(data) {

        return {
            type: trainingConstants.ALL_EXTERNAL_TRAINING_SUCCESS,
            payload: data
        }
    }

    function training_list_failure(err) {

        return {
            type: trainingConstants.ALL_EXTERNAL_TRAINING_FAILURE,
            payload: err
        }
    }

}